import { DragWidgetServiceBase } from './drag.widget.service.base';

export class UserflowDragWidgetService extends DragWidgetServiceBase {
    public override loadElements() {
        try {
            const userflow = document.querySelector(".userflowjs-resource-center");
            if (!userflow) {
                this.beginMoving();
                return
            }

            this.messengerContainerElem = userflow.querySelector("div.userflowjs-resource-center-frame-wrapper");
            this.frameElem = userflow.querySelector("iframe.userflowjs-resource-center-frame");

            if (!this.messengerContainerElem || !this.frameElem) {
                this.beginMoving();
            }
        } catch (error) {
            console.log(error);
            this.beginMoving();
        }
    }
}